module.exports = __webpack_public_path__ + "static/media/pin-user.ec24113d.svg";